"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _lodash = _interopRequireDefault(require("lodash"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Disclaimer = _interopRequireDefault(require("./Disclaimer.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "Disclaimer__MainWrapper",
  componentId: "sc-axedth-0"
})(["display:flex;border:1px solid;border-color:", ";padding:", ";border-radius:", ";background-color:", ";"], function (_ref) {
  var theme = _ref.theme,
    customStyles = _ref.customStyles;
  return "".concat(customStyles && customStyles.borderColor ? customStyles.borderColor : theme.colors.tertiaryYellow);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.space.XXXSmall);
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.borderRadius.normal);
}, function (_ref4) {
  var theme = _ref4.theme,
    customStyles = _ref4.customStyles;
  return "".concat(customStyles && customStyles.backgroundColor ? customStyles.backgroundColor : theme.backgroundColor.yellowLight);
});
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "Disclaimer__IconWrapper",
  componentId: "sc-axedth-1"
})(["padding-right:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return "".concat(theme.space.XXXSmall);
});
var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "Disclaimer__TextWrapper",
  componentId: "sc-axedth-2"
})(["display:flex;flex-wrap:wrap;"]);
var StyledText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "Disclaimer__StyledText",
  componentId: "sc-axedth-3"
})(["padding-bottom:", ";&:last-of-type{padding-bottom:", ";}font-family:", ";font-size:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.space.XXXSmall);
}, function (_ref7) {
  var theme = _ref7.theme;
  return "".concat(theme.space.none);
}, function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.fontFamily.default);
}, function (_ref9) {
  var theme = _ref9.theme,
    fontSize = _ref9.fontSize;
  return "".concat(theme.fontSize[fontSize]);
});
var StyledSpan = _styledComponents.default.span.withConfig({
  displayName: "Disclaimer__StyledSpan",
  componentId: "sc-axedth-4"
})(["a{color:", ";}"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.darkRed;
});
var Disclaimer = function Disclaimer(props) {
  var theme = props.theme,
    customProperties = props.customProperties,
    customStyles = props.customStyles,
    icon = props.icon,
    data = props.data;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var processLinks = function processLinks(htmlText, links) {
    var textWithLinks = _lodash.default.unescape(htmlText);
    if (links) {
      links.forEach(function (val, i) {
        textWithLinks = textWithLinks.replace("{".concat(i, "}"), val);
      });
    }
    return {
      __html: textWithLinks
    };
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(MainWrapper, {
      customStyles: customStyles
    }, icon && /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({}, customProperties, {
      theme: theme
      // eslint-disable-next-line react/prop-types
      ,
      color: customStyles === null || customStyles === void 0 ? void 0 : customStyles.iconColor,
      icon: icon,
      fontsize: "titleNormal"
    }))), /*#__PURE__*/_react.default.createElement(TextWrapper, null, data.map(function (disclaimer) {
      return /*#__PURE__*/_react.default.createElement(StyledText, customProperties, /*#__PURE__*/_react.default.createElement(StyledSpan, {
        dangerouslySetInnerHTML: processLinks(disclaimer.disclaimerText, disclaimer.links)
      }));
    })));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Disclaimer.propTypes = _Disclaimer.default.PropTypes;
Disclaimer.defaultProps = _Disclaimer.default.DefaultProps;
var _default = Disclaimer;
exports.default = _default;